<template>
  <div class="container-fluid">
    <div class="block-header position-sticky">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="d-md-flex">
      <div class="card mr-2">
        <div class="header border-bottom">
          <h5 class="text-primary font-weight-normal mb-0">Remitter Detail</h5>
        </div>
        <div class="body">
          <ul class="list-unstyled mb-0 striped-list">
            <li v-for="(item, index) in remitterData" :key="index">
              <div class="row">
                <div class="col-md-5">
                  <strong class="p-2 d-inline-block">{{ item.title }} :</strong>
                </div>
                <div class="col-md-7">
                  <span
                    class="p-2 d-inline-block"
                    v-if="index == 'transferAmount'"
                  >
                    {{
                      item.value
                        | amountFormat(item.currency || item.country?.isocode)
                    }}
                  </span>
                  <span class="p-2 d-inline-block" v-else>
                    {{ item.value ? item.value : "-" }}
                  </span>
                  <i
                    class="fa fa-copy"
                    v-if="item.value != '-' && item.copy"
                    @click="copyText(item.value, item.title)"
                  ></i>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="card">
        <div class="header border-bottom">
          <h5 class="text-primary font-weight-normal mb-0">Receiver Detail</h5>
        </div>
        <div class="body">
          <ul class="list-unstyled mb-0 striped-list">
            <li v-for="(item, index) in receiverData" :key="index">
              <div class="row">
                <div class="col-md-5">
                  <strong class="p-2 d-inline-block">{{ item.title }} :</strong>
                </div>
                <div class="col-md-7">
                  <span
                    class="p-2 d-inline-block"
                    v-if="item.title === 'Destination Amount'"
                  >
                    {{
                      item.value
                        | amountFormat(item.currency || item.country?.isocode)
                    }}
                  </span>
                  <span class="p-2 d-inline-block" v-else>
                    {{ item.value ? item.value : "-" }}
                  </span>
                  <i
                    class="fa fa-copy"
                    v-if="item.value != '-' && item.copy"
                    @click="copyText(item.value, item.title)"
                  ></i>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="footer d-flex justify-content-end mt-2">
          <button class="btn btn-primary" @click="openNameCheckModal">
            Check Name
          </button>
        </div>
        <b-modal
          id="nameCheckModal"
          title="Name Verification"
          @hidden="resetNameCheckModal"
        >
          <div class="form-group text-center">
            <label class="control-label font-weight-bold font-16">
              Full Name
            </label>
            <p class="form-control-static font-16">{{ checkedName }}</p>
          </div>
          <template #modal-footer="{ cancel }">
            <div class="w-100 d-flex flex-column align-items-center">
              <b-button
                variant="primary"
                @click="confirmNameChange"
                :disabled="isCheckingName"
                class="mb-2"
              >
                <span
                  v-if="isCheckingName"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                Are you sure you want to change the name?
              </b-button>
              <b-button variant="secondary" @click="cancel()">Cancel</b-button>
            </div>
          </template>
        </b-modal>
        <b-modal id="nameChangeLevelModal" title="Select Level">
          <div class="form-group">
            <p>Choose the level at which you want to change the name:</p>
          </div>
          <template #modal-footer="{ cancel }">
            <div class="w-100 d-flex flex-column align-items-center">
              <b-button
                variant="primary"
                @click="handleReceiverLevelChange"
                class="mb-2"
              >
                Receiver Level
              </b-button>
              <b-button
                variant="primary"
                @click="handleTransactionLevelChange"
                class="mb-2"
              >
                Transaction Level
              </b-button>
              <b-button variant="secondary" @click="cancel()">Cancel</b-button>
            </div>
          </template>
        </b-modal>
      </div>
    </div>
    <div class="d-md-flex">
      <div class="card mr-2">
        <div class="header border-bottom">
          <h5 class="text-primary font-weight-normal mb-0">
            Transaction Detail
          </h5>
        </div>
        <div class="body">
          <ul class="list-unstyled mb-0 striped-list">
            <li v-for="(item, index) in transactionData" :key="index">
              <div class="row">
                <div class="col-md-5">
                  <strong class="p-2 d-inline-block">{{ item.title }} :</strong>
                </div>
                <div class="col-md-7">
                  <span
                    class="p-2 d-inline-block"
                    v-if="item.title == 'Transaction Date' && item.value != '-'"
                  >
                    {{ item.value ? item.value : "-" | changeDateYYYYMMDD }}
                  </span>
                  <span class="p-2 d-inline-block" v-else>
                    {{ item.value ? item.value : "-" }}
                    <i
                      class="fa fa-copy"
                      v-if="item.value != '-' && item.copy"
                      @click="copyText(item.value, item.title)"
                    ></i>
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="card">
        <div class="header border-bottom">
          <h5 class="text-primary font-weight-normal mb-0">Payment Detail</h5>
        </div>
        <div class="body">
          <ul class="list-unstyled mb-0 striped-list">
            <li v-for="(item, index) in paymentData" :key="index">
              <div class="row">
                <div class="col-md-5">
                  <strong class="p-2 d-inline-block">{{ item.title }} :</strong>
                </div>
                <div class="col-md-7">
                  <span class="p-2 d-inline-block">
                    <template
                      v-if="
                        item.title === 'Used Card' &&
                        item.value &&
                        item.value !== '-'
                      "
                    >
                      XXXX-XXXX-{{ item.value }}
                    </template>
                    <template v-else>
                      {{ item.value ? item.value : "-" }}
                    </template>
                    <i
                      class="fa fa-copy"
                      v-if="item.value != '-' && item.copy"
                      @click="copyText(item.value, item.title)"
                    ></i>
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Wallet legit check (on-demand; wallet-funded only) -->
    <div class="d-md-flex" v-if="isWalletFunded">
      <div class="card w-100">
        <div class="header border-bottom d-flex align-items-center justify-content-between">
          <h5 class="text-primary font-weight-normal mb-0">
            Wallet Legitimacy
          </h5>
          <b-button
            size="sm"
            variant="outline-primary"
            :disabled="walletLegitLoading"
            @click="checkWalletLegitimate"
          >
            <span
              v-if="walletLegitLoading"
              class="spinner-border spinner-border-sm mr-1"
            ></span>
            {{ walletLegitLoading ? "Checking..." : "Check Legitimate" }}
          </b-button>
        </div>
        <div class="body" v-if="walletLegitResult">
          <div class="mb-3">
            <strong>Verdict:</strong>
            <span
              class="badge ml-2 px-2 py-1"
              :class="walletLegitBadgeClass"
            >
              {{ walletLegitResult.verdict }}
            </span>
          </div>
          <div v-if="walletLegitResult.funding" class="mb-3">
            <div class="row">
              <div class="col-md-4">
                <small class="text-muted d-block">Wallet amount</small>
                <strong>{{ walletLegitResult.funding.wallet_amount }}</strong>
              </div>
              <div class="col-md-4">
                <small class="text-muted d-block">Old balance</small>
                <strong>
                  {{
                    walletLegitResult.funding.old_balance === null
                      ? "N/A"
                      : walletLegitResult.funding.old_balance
                  }}
                </strong>
                <small
                  v-if="
                    walletLegitResult.funding.old_balance_source === 'assumed_zero'
                  "
                  class="text-warning d-block"
                >
                  (no legacy balance row — assumed 0)
                </small>
              </div>
              <div class="col-md-4">
                <small class="text-muted d-block">Post-migration credits</small>
                <strong>{{
                  walletLegitResult.funding.post_migration_credits
                }}</strong>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4">
                <small class="text-muted d-block">Prior wallet spends</small>
                <strong>{{
                  walletLegitResult.funding.prior_wallet_spends
                }}</strong>
                <small
                  v-if="walletLegitResult.funding.prior_spends_excluded_reversed"
                  class="text-muted d-block"
                >
                  (excluded unused reversed/expired:
                  {{ walletLegitResult.funding.prior_spends_excluded_reversed }})
                </small>
                <small
                  v-if="walletLegitResult.funding.prior_spends_kept_released_but_paid"
                  class="text-warning d-block"
                >
                  (kept released-but-paid:
                  {{ walletLegitResult.funding.prior_spends_kept_released_but_paid }})
                </small>
              </div>
              <div class="col-md-4">
                <small class="text-muted d-block">Legitimate source</small>
                <strong>{{
                  walletLegitResult.funding.legitimate_source === null
                    ? "N/A"
                    : walletLegitResult.funding.legitimate_source
                }}</strong>
              </div>
              <div class="col-md-4">
                <small class="text-muted d-block">Covers this tx</small>
                <strong>{{
                  walletLegitResult.funding.covers_this_tx === null
                    ? "N/A"
                    : walletLegitResult.funding.covers_this_tx
                    ? "Yes"
                    : "No"
                }}</strong>
              </div>
            </div>
            <div
              v-if="walletLegitResult.funding.hold"
              class="row mt-2"
            >
              <div class="col-md-4">
                <small class="text-muted d-block">Wallet hold</small>
                <strong>{{
                  walletLegitResult.funding.hold.lifecycle || "N/A"
                }}</strong>
                <small class="text-muted d-block">
                  via {{ walletLegitResult.funding.hold.source || "n/a" }}
                </small>
              </div>
            </div>
          </div>
          <ul class="list-unstyled mb-0">
            <li
              v-for="(check, idx) in walletLegitResult.checks"
              :key="idx"
              class="mb-2 p-2 border rounded"
            >
              <span
                class="badge mr-2"
                :class="{
                  'badge-success': check.status === 'pass',
                  'badge-danger': check.status === 'fail',
                  'badge-warning': check.status === 'warn',
                  'badge-secondary': check.status === 'skip',
                }"
              >
                {{ check.status }}
              </span>
              <strong>{{ check.code }}</strong>
              — {{ check.message }}
            </li>
          </ul>
        </div>
        <div class="body text-muted" v-else>
          Click <strong>Check Legitimate</strong> to evaluate this wallet-funded
          transfer.
        </div>
      </div>
    </div>

    <!-- Payout Detail Section -->
    <div class="d-md-flex">
      <div class="card">
        <div class="header border-bottom">
          <h5 class="text-primary font-weight-normal mb-0">Payout Detail</h5>
        </div>
        <div class="body">
          <ul class="list-unstyled mb-0 striped-list">
            <li v-for="(item, index) in payoutDetailData" :key="index">
              <div class="row">
                <div class="col-md-5">
                  <strong class="p-2 d-inline-block">{{ item.title }} :</strong>
                </div>
                <div class="col-md-7">
                  <span
                    class="p-2 d-inline-block"
                    v-if="item.title === 'E-Wallet Amount'"
                  >
                    <template
                      v-if="
                        payoutDetailData.payoutReferenceId &&
                        payoutDetailData.payoutReferenceId.value &&
                        payoutDetailData.payoutReferenceId.value !== '-'
                      "
                    >
                      {{
                        payoutDetailData.walletAmt &&
                        payoutDetailData.walletAmt.value
                          ? payoutDetailData.walletAmt.value
                          : "0"
                      }}
                    </template>
                    <template v-else>-</template>
                  </span>
                  <span class="p-2 d-inline-block" v-else>
                    {{ item.value ? item.value : "-" }}
                  </span>
                  <i
                    class="fa fa-copy"
                    v-if="item.value != '-' && item.copy"
                    @click="copyText(item.value, item.title)"
                  ></i>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card comment-box">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">Comments</h5>
          </div>
          <div class="body" ref="comments">
            <div
              class="d-block"
              v-for="(item, index) in usercomments"
              :key="index"
            >
              <span class="font-weight-bold font-14 mr-2">{{ item.name }}</span>
              <span class="font-12">{{ item.date | changeDateYYYYMMDD }}</span>
              <span v-if="item.created_by" class="font-12 ml-3">Posted By <span class="font-weight-bold">{{ item.created_by }}</span></span>
              <div class="card p-3">
                <p>{{ item.comment }}</p>
                <!-- <div class="d-block ml-4" v-if="item.edited">
                                    Edited By <span class="font-weight-bold font-14 mr-2">{{item.editedby}}</span><span class="font-12">{{item.editOn}}</span>
                                    <div class="card p-3">
                                        <p class="mb-0">{{item.editMsg}}</p>
                                    </div>
                                </div> -->
                <!-- ENG-1488: edit icon hidden to enforce comment immutability
                <i
                  class="fa fa-edit text-right"
                  @click="openEditModal(item)"
                  v-b-modal.editComment
                ></i>
                -->
              </div>
            </div>
          </div>
          <b-modal
            id="editComment"
            title="Edit Comment"
            @hidden="resetEditModal"
          >
            <form @submit.prevent="updateCommentHandler">
              <div class="form-group">
                <label for="editComment" class="control-label">Comment</label>
                <textarea
                  class="form-control"
                  :class="{ 'is-invalid': editCommentError }"
                  id="editComment"
                  v-model="editComentMsg"
                  @input="clearEditError"
                  placeholder="Enter your comment..."
                  rows="4"
                ></textarea>
                <div v-if="editCommentError" class="text-danger small mt-1">
                  <i class="fa fa-exclamation-circle mr-1"></i>
                  {{ editCommentError }}
                </div>
              </div>
            </form>
            <template
              #modal-footer="{ cancel }"
              v-if="
                $store.getters['authpermission/hasAnyPermission']([
                  'transaction.updatecomment',
                ])
              "
            >
              <b-button variant="secondary" @click="cancel()">Cancel</b-button>
              <b-button
                variant="primary"
                @click="updateCommentHandler"
                :disabled="isEditingComment"
              >
                <span
                  v-if="isEditingComment"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                Update Comment
              </b-button>
            </template>
          </b-modal>
          <div class="footer m-0 w-100 p-2">
            <div class="d-flex justify-content-between flex-column">
              <div class="d-flex justify-content-between mb-2">
                <input
                  type="text"
                  class="form-control mr-2"
                  :class="{ 'is-invalid': commentError }"
                  v-model="addComment"
                  @input="clearError"
                  placeholder="Enter your comment..."
                />
                <template
                  v-if="
                    $store.getters['authpermission/hasAnyPermission']([
                      'transaction.addcomment',
                    ])
                  "
                >
                  <button
                    class="btn btn-primary"
                    @click="addCommentHandler"
                    :disabled="isSubmitting"
                  >
                    <span
                      v-if="isSubmitting"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    Add Comment
                  </button>
                </template>
              </div>
              <div v-if="commentError" class="text-danger small">
                <i class="fa fa-exclamation-circle mr-1"></i>
                {{ commentError }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">Payment Logs</h5>
          </div>
          <div class="body">
            <div
              class="d-block mb-1"
              v-for="(item, index) in paymentLogs"
              :key="index"
            >
              <div
                class="border bg-dark-50 p-2 accordian-toggle"
                v-b-toggle="`paymentLogs-${index}`"
              >
                <div class="d-flex justify-content-between">
                  <div class="">
                    <strong class="mr-2">Transaction Ref Id:</strong>
                    <span>{{ item.transactionid }}</span>
                  </div>
                  <div class="mr-5">
                    <span class="font-12 mr-2">
                      {{ item.requestDate | changeDateYYYYMMDDTZ }}
                    </span>
                  </div>
                </div>
              </div>
              <b-collapse
                :id="`paymentLogs-${index}`"
                class="border border-top-0"
              >
                <div class="p-2">
                  <div class="mb-1" v-if="item.logType">
                    <strong>Log Type:</strong>
                    <span>{{ item.logType }}</span>
                  </div>
                  <div class="mb-1">
                    <strong>Payment Id:{{ " " }}</strong>
                    <span>{{ item.payment_id || "--" }}</span>
                  </div>
                  <div class="mb-1">
                    <strong>Status:</strong>
                    <span>{{ item.status || "N/A" }}</span>
                  </div>
                  <div class="mb-1" v-if="item.event_type">
                    <strong>Event Type:</strong>
                    <span>{{ item.event_type }}</span>
                  </div>
                  <div class="mb-1" v-if="item.response_code">
                    <strong>Response Code:</strong>
                    <span>{{ item.response_code }}</span>
                  </div>
                  <div class="mb-1">
                    <strong>Request Date:</strong>
                    <span>{{ item.requestDate | changeDateYYYYMMDD }}</span>
                  </div>
                  <div class="mb-1" v-if="item.payment_req">
                    <div class="d-flex align-items-center mb-1">
                      <strong>Request:</strong>
                      <button
                        class="btn btn-sm btn-link p-0 ml-2"
                        @click="
                          $set(item, 'requestExpanded', !item.requestExpanded)
                        "
                      >
                        <i
                          :class="
                            item.requestExpanded
                              ? 'fa fa-chevron-up'
                              : 'fa fa-chevron-down'
                          "
                        ></i>
                        {{ item.requestExpanded ? "Collapse" : "Expand" }}
                      </button>
                    </div>
                    <pre
                      v-if="item.requestExpanded"
                      class="bg-light p-2 rounded"
                      style="max-height: 300px; overflow-y: auto"
                      >{{
                        typeof item.payment_req === "string"
                          ? JSON.stringify(
                              JSON.parse(item.payment_req),
                              null,
                              2,
                            )
                          : JSON.stringify(item.payment_req, null, 2)
                      }}</pre
                    >
                  </div>
                  <div class="mb-1">
                    <strong>Response Date:</strong>
                    <span>{{ item.responseDate | changeDateYYYYMMDD }}</span>
                  </div>
                  <div class="mb-1" v-if="item.payment_res">
                    <div class="d-flex align-items-center mb-1">
                      <strong>Response:</strong>
                      <button
                        class="btn btn-sm btn-link p-0 ml-2"
                        @click="
                          $set(item, 'responseExpanded', !item.responseExpanded)
                        "
                      >
                        <i
                          :class="
                            item.responseExpanded
                              ? 'fa fa-chevron-up'
                              : 'fa fa-chevron-down'
                          "
                        ></i>
                        {{ item.responseExpanded ? "Collapse" : "Expand" }}
                      </button>
                    </div>
                    <pre
                      v-if="item.responseExpanded"
                      class="bg-light p-2 rounded"
                      style="max-height: 300px; overflow-y: auto"
                      >{{
                        typeof item.payment_res === "string"
                          ? JSON.stringify(
                              JSON.parse(item.payment_res),
                              null,
                              2,
                            )
                          : JSON.stringify(item.payment_res, null, 2)
                      }}</pre
                    >
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div
            class="header border-bottom accordian-toggle"
            v-b-toggle.activityLogs
          >
            <h5 class="text-primary font-weight-normal mb-0">
              Admin Activity Logs
            </h5>
          </div>
          <b-collapse id="activityLogs" @show="getActivityLogs">
            <div class="body">
              <div v-if="activityLogsLoading" class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2 text-muted">Loading activity logs...</p>
              </div>
              <div
                v-else-if="activityLogs.length === 0"
                class="text-center text-muted p-3"
              >
                No activity logs available
              </div>
              <div
                v-else
                class="d-block accordion mb-1"
                v-for="(log, index) in activityLogs"
                :key="index"
              >
                <div class="border bg-dark-50 p-2">
                  <div class="row">
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <span class="font-weight-bold">
                        {{
                          log.user && log.user.username
                            ? log.user.username
                            : "System"
                        }}
                      </span>
                    </div>
                    <div class="col-12 col-md-6 mb-2 mb-md-0">
                      <span>{{ log.timestamp | changeDateYYYYMMDD }}</span>
                    </div>
                    <div
                      class="col-12 col-md-3 d-flex align-items-center justify-content-md-end"
                    >
                      <span
                        class="font-weight-bold mr-2"
                        :class="
                          log.outcome === 'success'
                            ? 'text-success'
                            : 'text-danger'
                        "
                      >
                        {{ log.outcome ? log.outcome.toUpperCase() : "N/A" }}
                      </span>
                      <span></span>
                    </div>
                  </div>
                </div>
                <div class="border border-top-0 p-2">
                  <div class="row">
                    <!-- Action Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Action</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(log, 'actionExpanded', !log.actionExpanded)
                            "
                          >
                            <i
                              :class="
                                log.actionExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div v-if="log.actionExpanded">
                          <div class="small">
                            <strong>{{ getActionText(log.method) }}</strong>
                            <div class="mt-1 text-muted">
                              Section:
                              {{
                                log.request && log.request.url
                                  ? log.request.url
                                  : "N/A"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Request Sent Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Request Sent</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(log, 'requestExpanded', !log.requestExpanded)
                            "
                          >
                            <i
                              :class="
                                log.requestExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div
                          v-if="
                            log.requestExpanded &&
                            log.request &&
                            log.request.body
                          "
                        >
                          <pre
                            class="bg-white p-2 rounded small mb-0"
                            style="max-height: 300px; overflow-y: auto"
                            >{{
                              JSON.stringify(log.request.body, null, 2)
                            }}</pre
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Response Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Response</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(
                                log,
                                'responseExpanded',
                                !log.responseExpanded,
                              )
                            "
                          >
                            <i
                              :class="
                                log.responseExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div
                          v-if="
                            log.responseExpanded &&
                            log.response &&
                            log.response.body
                          "
                        >
                          <pre
                            class="bg-white p-2 rounded small mb-0"
                            style="max-height: 300px; overflow-y: auto"
                            >{{
                              JSON.stringify(log.response.body, null, 2)
                            }}</pre
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Device Info Column -->
                    <div class="col-12 col-md-3 mb-2 mb-md-0">
                      <div class="border bg-light p-2 rounded">
                        <div
                          class="d-flex align-items-center justify-content-between mb-1"
                        >
                          <strong>Device Info</strong>
                          <button
                            class="btn btn-sm btn-link p-0"
                            @click="
                              $set(
                                log,
                                'deviceInfoExpanded',
                                !log.deviceInfoExpanded,
                              )
                            "
                          >
                            <i
                              :class="
                                log.deviceInfoExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                          </button>
                        </div>
                        <div v-if="log.deviceInfoExpanded && log.device">
                          <pre
                            class="bg-white p-2 rounded small mb-0"
                            style="max-height: 300px; overflow-y: auto"
                            >{{ JSON.stringify(log.device, null, 2) }}</pre
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">
              Provider Response
            </h5>
          </div>
          <div class="body">
            <div
              class="d-block accordion mb-1"
              v-for="(item, index) in payoutAttempts"
              :key="index"
            >
              <div
                class="border bg-dark-50 p-2"
                v-b-toggle="`log-${index}`"
                @click="onAccordionToggle(item.id, index)"
              >
                <div class="row">
                  <div class="col-12 col-md-3 mb-2 mb-md-0">
                    <strong class="mr-2">Transaction Id:</strong>
                    <span class="text-break">{{ item.id }}</span>
                  </div>
                  <div class="col-6 col-md-3 mb-2 mb-md-0">
                    <strong class="mr-2">Provider:</strong>
                    <span>{{ item.provider_name }}</span>
                  </div>
                  <div class="col-6 col-md-3 mb-2 mb-md-0">
                    <strong class="mr-2">Status:</strong>
                    <span>{{ item.payout_status_name }}</span>
                  </div>
                  <div
                    class="col-12 col-md-3 d-flex align-items-center justify-content-md-end"
                  >
                    <span class="font-12 mr-2">
                      {{ item.updated_at | changeDateYYYYMMDDTZ }}
                    </span>
                    <i class="fa fa-chevron-up open"></i>
                    <i class="fa fa-chevron-down closed"></i>
                  </div>
                </div>
              </div>
              <b-collapse :id="`log-${index}`" class="border border-top-0">
                <div
                  class="p-2"
                  v-if="
                    providerResponseCache[item.id] &&
                    providerResponseCache[item.id].data &&
                    providerResponseCache[item.id].data.length > 0
                  "
                >
                  <div
                    v-for="(dataItem, dataIndex) in providerResponseCache[
                      item.id
                    ].data"
                    :key="dataIndex"
                    class="mb-3"
                    :class="{
                      'border-bottom pb-3':
                        dataIndex <
                        providerResponseCache[item.id].data.length - 1,
                    }"
                  >
                    <!-- PayoutLog Section -->
                    <div v-if="dataItem.source === 'payoutLog' && dataItem.payload && dataItem.payload.type !== 'response'">
                      <div class="mb-2">
                        <strong class="text-info">Request From ARCH</strong>
                      </div>
                      <div class="mb-1">
                        <strong>Transaction ID:</strong>
                        <span>{{ dataItem.transactionId }}</span>
                      </div>
                      <div class="mb-1" v-if="dataItem.payload">
                        <div class="d-flex align-items-center mb-1">
                          <strong>Payload:</strong>
                          <button
                            class="btn btn-sm btn-link p-0 ml-2"
                            @click="
                              $set(
                                dataItem,
                                'payloadExpanded',
                                !dataItem.payloadExpanded,
                              )
                            "
                          >
                            <i
                              :class="
                                dataItem.payloadExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                            {{
                              dataItem.payloadExpanded ? "Collapse" : "Expand"
                            }}
                          </button>
                        </div>
                        <pre
                          v-if="dataItem.payloadExpanded"
                          class="bg-light p-2 rounded"
                          >{{ JSON.stringify(dataItem.payload, (key, value) => key === 'type' ? undefined : value, 2) }}</pre
                        >
                      </div>
                      <div class="mb-1">
                        <strong>Timestamp:</strong>
                        <span>
                          {{ dataItem.timestamp | changeDateYYYYMMDD }}
                        </span>
                      </div>
                    </div>

                    <!-- PayoutLog Response Section -->
                    <div v-else-if="dataItem.source === 'payoutLog' && dataItem.payload && dataItem.payload.type === 'response'">
                      <div class="mb-2">
                        <strong :class="dataItem.payload.statusCode === 400 ? 'text-danger' : 'text-success'">Response From PayConnect</strong>
                      </div>
                      <div class="mb-1">
                        <strong>Transaction ID:</strong>
                        <span>{{ dataItem.transactionId }}</span>
                      </div>
                      <div class="mb-1">
                        <strong>Status Code:</strong>
                        <span>{{ dataItem.payload.statusCode }}</span>
                      </div>
                      <div class="mb-1" v-if="dataItem.payload.message">
                        <div class="d-flex align-items-center mb-1">
                          <strong>Message:</strong>
                          <button
                            class="btn btn-sm btn-link p-0 ml-2"
                            @click="$set(dataItem, 'responseMessageExpanded', !dataItem.responseMessageExpanded)"
                          >
                            <i :class="dataItem.responseMessageExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                            {{ dataItem.responseMessageExpanded ? "Collapse" : "Expand" }}
                          </button>
                        </div>
                        <pre v-if="dataItem.responseMessageExpanded" class="bg-light p-2 rounded">{{ JSON.stringify(dataItem.payload.message, null, 2) }}</pre>
                      </div>
                      <div class="mb-1">
                        <strong>Timestamp:</strong>
                        <span>{{ dataItem.timestamp | changeDateYYYYMMDD }}</span>
                      </div>
                    </div>

                    <!-- ProviderData Section -->
                    <div v-else-if="dataItem.source === 'providerData'">
                      <div class="mb-2">
                        <strong class="text-success">
                          Response From PayConnect
                        </strong>
                      </div>
                      <div class="mb-1" v-if="dataItem.request">
                        <div class="d-flex align-items-center mb-1">
                          <strong>Request:</strong>
                          <button
                            class="btn btn-sm btn-link p-0 ml-2"
                            @click="
                              $set(
                                dataItem,
                                'requestExpanded',
                                !dataItem.requestExpanded,
                              )
                            "
                          >
                            <i
                              :class="
                                dataItem.requestExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                            {{
                              dataItem.requestExpanded ? "Collapse" : "Expand"
                            }}
                          </button>
                        </div>
                        <pre
                          v-if="dataItem.requestExpanded"
                          class="bg-light p-2 rounded"
                          >{{
                            typeof dataItem.request === "string"
                              ? (() => { try { return JSON.stringify(JSON.parse(dataItem.request), null, 2); } catch(e) { return dataItem.request; } })()
                              : JSON.stringify(dataItem.request, null, 2)
                          }}</pre
                        >
                      </div>
                      <div class="mb-1">
                        <strong>Request Date:</strong>
                        <span>
                          {{ dataItem.requestDate | changeDateYYYYMMDD }}
                        </span>
                      </div>
                      <div class="mb-1" v-if="dataItem.response">
                        <div class="d-flex align-items-center mb-1">
                          <strong>Response:</strong>
                          <button
                            class="btn btn-sm btn-link p-0 ml-2"
                            @click="
                              $set(
                                dataItem,
                                'responseExpanded',
                                !dataItem.responseExpanded,
                              )
                            "
                          >
                            <i
                              :class="
                                dataItem.responseExpanded
                                  ? 'fa fa-chevron-up'
                                  : 'fa fa-chevron-down'
                              "
                            ></i>
                            {{
                              dataItem.responseExpanded ? "Collapse" : "Expand"
                            }}
                          </button>
                        </div>
                        <pre
                          v-if="dataItem.responseExpanded"
                          class="bg-light p-2 rounded"
                          >{{
                            typeof dataItem.response === "string"
                              ? JSON.stringify(
                                  JSON.parse(dataItem.response),
                                  null,
                                  2,
                                )
                              : JSON.stringify(dataItem.response, null, 2)
                          }}</pre
                        >
                      </div>
                      <div class="mb-1">
                        <strong>Response Date:</strong>
                        <span>
                          {{ dataItem.responseDate | changeDateYYYYMMDD }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-2" v-else>
                  <p class="text-muted">No provider response data available</p>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card" v-if="false">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">
              Transaction Notification logs
            </h5>
          </div>
          <div class="body">
            <div class="d-block accordion mb-1">
              <div class="border bg-dark-50 p-2" v-b-toggle.transaction-log-1>
                <div class="row">
                  <div class="col-3 d-flex align-items-center">
                    <span class="font-weight-bold font-14">Mark Richards</span>
                  </div>
                  <div class="col-3 d-flex">
                    <strong class="mr-2">Notification Type:</strong>
                    <span>Push Notification</span>
                  </div>
                  <div class="col-3 d-flex">
                    <strong class="mr-2">Notification Action:</strong>
                    <span>ID Notification</span>
                  </div>
                  <div
                    class="col-3 d-flex align-items-center justify-content-end"
                  >
                    <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                    <i class="fa fa-chevron-up open"></i>
                    <i class="fa fa-chevron-down closed"></i>
                  </div>
                </div>
              </div>
              <b-collapse
                id="transaction-log-1"
                class="p-2 border border-top-0"
              >
                <strong>Message:</strong>
                <span class="ml-3">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged.
                  </p>
                </span>
              </b-collapse>
            </div>
            <div class="d-block accordion mb-1">
              <div class="border bg-dark-50 p-2" v-b-toggle.transaction-log-2>
                <div class="row">
                  <div class="col-3 d-flex align-items-center">
                    <span class="font-weight-bold font-14">Selena Parker</span>
                  </div>
                  <div class="col-3 d-flex">
                    <strong class="mr-2">Notification Type:</strong>
                    <span>Dismiss popup</span>
                  </div>
                  <div class="col-3 d-flex">
                    <strong class="mr-2">Notification Action:</strong>
                    <span>ID Notification</span>
                  </div>
                  <div
                    class="col-3 d-flex align-items-center justify-content-end"
                  >
                    <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                    <i class="fa fa-chevron-up open"></i>
                    <i class="fa fa-chevron-down closed"></i>
                  </div>
                </div>
              </div>
              <b-collapse
                id="transaction-log-2"
                class="p-2 border border-top-0"
              >
                <strong>Message:</strong>
                <span class="ml-3">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged.
                  </p>
                </span>
              </b-collapse>
            </div>
            <div class="d-block accordion mb-1">
              <div class="border bg-dark-50 p-2" v-b-toggle.transaction-log-3>
                <div class="row">
                  <div class="col-3 d-flex align-items-center">
                    <span class="font-weight-bold font-14">
                      Lusifer Boswell
                    </span>
                  </div>
                  <div class="col-3 d-flex">
                    <strong class="mr-2">Notification Type:</strong>
                    <span>SMS</span>
                  </div>
                  <div class="col-3 d-flex">
                    <strong class="mr-2">Notification Action:</strong>
                    <span>Other</span>
                  </div>
                  <div
                    class="col-3 d-flex align-items-center justify-content-end"
                  >
                    <span class="font-12 mr-2">2022-08-19 06:37:47</span>
                    <i class="fa fa-chevron-up open"></i>
                    <i class="fa fa-chevron-down closed"></i>
                  </div>
                </div>
              </div>
              <b-collapse
                id="transaction-log-3"
                class="p-2 border border-top-0"
              >
                <strong>Message:</strong>
                <span class="ml-3">
                  <p>RE : [trans_ref_#]</p>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged.
                  </p>
                </span>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import {
  GET_TRANSACTION_REMITTER_RECEIVER_DETAILS,
  GET_TRANSACTION_PAYMENT_DETAILS,
  GET_WALLET_LEGIT,
  GET_TRANSACTION_PAYOUT_DETAILS,
  GET_TRANSACTION_PROVIDER_RESPONSE,
  GET_PAYOUT_ATTEMPTS,
  GET_TRANSACTION_COMMENTS,
  POST_TRANSACTION_COMMENT,
  UPDATE_TRANSACTION_COMMENT,
  GET_TRANSACTION_PAYMENTS_LOGS,
  GET_NAME_FROM_NAMECHECK,
  UPDATE_RECEIVER_NAME,
} from "../../../store/actions.type.js";
import { mapGetters } from "vuex";
export default {
  name: "TransactionDetailComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      remitterData: [
        { title: "Remitter Id", value: "-", copy: true },
        { title: "Company Name", value: "-" },
        { title: "Email", value: "-", copy: true },
        { title: "Country of Residence", value: "-" },
        { title: "Mobile", value: "-", copy: true },
        { title: "Source Transfer Amount", value: "" },
      ],
      receiverData: [
        { title: "Beneficiary name", value: "-", copy: true },
        { title: "Destination Amount", value: "-" },
        { title: "Account Number", value: "-", copy: true },
      ],
      transactionData: [
        { title: "Transaction Creation Channel", value: "-" },
        { title: "Registered IP", value: "-", copy: true },
        { title: "Transaction Date", value: "-" },
        { title: "Transaction Ref", value: "-", copy: true },
        { title: "Transaction Status", value: "-" },
        { title: "Generic Status(3DS) ", value: "-" },
        { title: "Payment gateway Status", value: "-" },
      ],
      paymentData: [
        { title: "PayAngel Ref", value: "-", copy: true },
        { title: "Intdidual Transaction Fee", value: "-" },
        { title: "Intdidual Charge (Payment Method)", value: "-" },
        { title: "Intdidual Discount Amount", value: "-" },
        { title: "Intdidual Donate Amount", value: "-" },
        { title: "Intdidual Charity Amount", value: "-" },
        { title: "E-Wallet Amount", value: "-" },
        { title: "Payment Amount", value: "-" },
        { title: "Reason of Remittance", value: "-" },
        { title: "Funding Option", value: "-" },
        { title: "Exchange Rate", value: "-" },
        { title: "Used Card", value: "-" },
        { title: "Payout Mode", value: "-" },
      ],
      providerResponse: "",
      providerResponseCache: {}, // Cache for provider responses by transaction ID
      accordionStates: {}, // Track which accordions are open/closed
      payoutAttempts: [],
      paymentLogs: "",
      isWalletFunded: false,
      walletLegitLoading: false,
      walletLegitResult: null,
      breadCrumbIteams: [
        {
          title: "Transaction",
          links: "",
        },
        {
          title: "Transaction Detail",
          links: "",
        },
      ],
      addComment: null,
      commentError: "",
      isSubmitting: false,
      editComentMsg: null,
      editCommentError: "",
      isEditingComment: false,
      currentEditComment: null,
      checkedName: "",
      isCheckingName: false,
      // When true, don't clear `checkedName` in the name-check modal hidden handler
      skipResetOnHide: false,
      usercomments: [
        // {
        //     name:'Alizee Thomas',
        //     date:'2024-05-28 13:43:28',
        //     comment:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
        //     edited:false,
        //     editedby:'',
        //     editMsg:'',
        //     editOn:''
        // },
        // {
        //     name:'Jacob',
        //     date:'2024-05-29 13:43:28',
        //     comment:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
        //     edited:false,
        //     editedby:'',
        //     editMsg:'',
        //     editOn:''
        // },
        // {
        //     name:'Michael',
        //     date:'2024-06-22 13:43:28',
        //     comment:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
        //     edited:true,
        //     editedby:'Tony',
        //     editMsg:'Lorem Ipsum is dummy',
        //     editOn:'2024-06-25 17:29:28'
        // },
        // {
        //     name:'Charlotte',
        //     date:'2024-06-08 13:43:28',
        //     comment:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
        //     edited:false,
        //     editedby:'',
        //     editMsg:'',
        //     editOn:''
        // },
        // {
        //     name:'Amelia',
        //     date:'2024-06-23 13:43:28',
        //     comment:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
        //     edited:true,
        //     editedby:'Mark',
        //     editMsg:'Lorem Ipsum is dummy',
        //     editOn:'2024-06-24 10:10:25'
        // }
      ],

      payoutDetailData: [
        { title: "Payout Reference Id", value: "-" },
        { title: "Payout Provider", value: "-" },
        { title: "Payout Status", value: "-" },
        { title: "E-Wallet Amount", value: "-" },
        { title: "PayConnect Id", value: "-" },
      ],
      activityLogs: [],
      activityLogsLoading: false,
    };
  },
  methods: {
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      this.$toast.success(`${type} Copied`, { position: "top-right" });
    },
    cancel() {
      this.$router.push({ path: "/transaction/list" });
    },
    scrollToLatest() {
      const parentElement = this.$refs.comments;
      parentElement.scrollTop = parentElement.scrollHeight + 100;
      parentElement.lastChildElement?.scrollIntoView({
        behavior: "smooth",
      });
    },
    async remitterReceiverDetails() {
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.ref_no,
        "ref_no",
      ).toString(this.$CryptoJS.enc.Utf8);
      await this.$store
        .dispatch(GET_TRANSACTION_REMITTER_RECEIVER_DETAILS, id)
        .then((response) => {
          if (response.status == 200) {
            let details = response.data.details;
            let tempremitter = {
              remitterid: {
                title: "Customer Id",
                value: details.remitterid ? details.remitterid : "-",
                copy: true,
              },
              sendername: {
                title: "Sender Name",
                value: details.sendername ? details.sendername : "-",
              },
              email: {
                title: "Email",
                value: details.email ? details.email : "-",
                copy: true,
              },
              countryofResidence: {
                title: "Country of Residence",
                value: details.countryofResidence
                  ? details.countryofResidence
                  : "-",
              },
              mobile: {
                title: "Mobile",
                value: details.mobile ? details.mobile : "-",
                copy: true,
              },
              transferAmount: {
                title: "Source Transfer Amount",
                value: details.transferAmount ? details.transferAmount : "-",
                currency: details.sendingCurrency || "",
                country:
                  this.countryList.filter(
                    (data) => data.currencycode === details.sendingCurrency,
                  )[0] || {},
              },
              senderCountry: {
                title: "Sender Country",
                value: details.senderCountry ? details.senderCountry : "-",
              },
            };

            // Build receiverData array based on payout_option_name
            let receiverDataArr = [];
            receiverDataArr.push({
              title: "Beneficiary name",
              value: details.beneficiaryName ? details.beneficiaryName : "-",
              copy: true,
            });
            receiverDataArr.push({
              title: "Destination Amount",
              value: details.destAmount ? details.destAmount : "-",
              currency: details.receivingCurrency || "",
              country:
                this.countryList.filter(
                  (data) => data.currencycode === details.receivingCurrency,
                )[0] || {},
            });

            if (details.payout_option_name === "Bank Deposit") {
              receiverDataArr.push({
                title: "Bank Account Number",
                value: details.accountNumber ? details.accountNumber : "-",
                copy: true,
              });
              receiverDataArr.push({
                title: "Bank Name",
                value: details.bankname ? details.bankname : "-",
              });
            } else if (details.payout_option_name === "Mobile Money") {
              receiverDataArr.push({
                title: "Mobile Number",
                value: details.beneficiaryMobileNumber
                  ? details.beneficiaryMobileNumber
                  : "-",
                copy: true,
              });
              receiverDataArr.push({
                title: "Mobile Network",
                value: details.beneficiaryMobileNetwork
                  ? details.beneficiaryMobileNetwork
                  : "-",
              });
            }

            receiverDataArr.push({
              title: "Beneficiary Country",
              value: details.beneficiaryCountry
                ? details.beneficiaryCountry
                : "-",
            });
            receiverDataArr.push({
              title: "Relationship with Sender",
              value: details.beneficiaryRelationship
                ? details.beneficiaryRelationship
                : "-",
            });

            this.remitterData = tempremitter;
            this.receiverData = receiverDataArr;
          }
        });
    },
    async paymentDetails() {
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.ref_no,
        "ref_no",
      ).toString(this.$CryptoJS.enc.Utf8);
      await this.$store
        .dispatch(GET_TRANSACTION_PAYMENT_DETAILS, id)
        .then((response) => {
          if (response.status == 200) {
            let details = response.data.details;
            let temptransaction = {
              transactionCreationChanel: {
                title: "Transaction Creation Channel",
                value: details.transactionCreationChanel
                  ? details.transactionCreationChanel
                  : "-",
              },
              ipaddress: {
                title: "Registered IP",
                value: details.registered_ip ? details.registered_ip : "-",
                copy: true,
              },
              transactiondate: {
                title: "Transaction Date",
                value: details.transactiondate ? details.transactiondate : "-",
              },
              transactionref: {
                title: "Transaction Ref",
                value: details.transactionref ? details.transactionref : "-",
                copy: true,
              },
              transactionStatus: {
                title: "Transaction Status",
                value: details.transactionStatus
                  ? details.transactionStatus
                  : "-",
              },
              // generic3dsStatus:{ title: 'Generic Status(3DS) ', value:  details.generic3dsStatus ? details.generic3dsStatus :'-' },
              // paymentGatewayStatus:{ title: 'Payment gateway Status', value:  details.paymentGatewayStatus ? details.paymentGatewayStatus :'-' },
            };
            let tempPayment = {
              paymentReferenceId: {
                title: "Payment Reference Id",
                value: details.paymentReferenceId
                  ? details.paymentReferenceId
                  : "-",
                copy: true,
              },
              transactionFees: {
                title: "Individual Transaction Fee",
                value: details.transactionFees ? details.transactionFees : "-",
              },
              // paymentcharge:{ title: 'Intdidual Charge (Payment Method)', value:  details.paymentcharge ? details.paymentcharge :'-' },
              // discountAmt:{ title: 'Intdidual Discount Amount', value:  details.discountAmt ? details.discountAmt :'-' },
              // donateAmt:{ title: 'Intdidual Donate Amount', value:  details.donateAmt ? details.donateAmt :'-' },
              // charityAmt:{ title: 'Intdidual Charity Amount', value:  details.charityAmt ? details.charityAmt :'-' },
              walletAmt: {
                title: "E-Wallet Amount",
                value: details.senderWalletAmount
                  ? details.senderWalletAmount
                  : "0",
              },
              paymentAmt: {
                title: "Payment Amount",
                value: details.paymentAmt ? details.paymentAmt : "-",
              },
              reasonRemitance: {
                title: "Reason of Remittance",
                value: details.reasonRemitance ? details.reasonRemitance : "-",
              },
              // fundingOption:{ title: 'Funding Option', value:  details.fundingOption ? details.fundingOption :'-' },
              exchangeRate: {
                title: "Exchange Rate",
                value: details.exchangeRate ? details.exchangeRate : "-",
              },
              usedCard: {
                title: "Used Card",
                value: details.usedCard ? details.usedCard : "-",
              },
              // payoutMode:{ title: 'Payout Mode', value:  details.payoutMode ? details.payoutMode :'-' },
              paymentProvider: {
                title: "Payment Provider",
                value: details.providerName ? details.providerName : "-",
              },
              paymentStatus: {
                title: "Payment Status",
                value: details.paymentStatus ? details.paymentStatus : "-",
              },
            };
            this.transactionData = temptransaction;
            this.paymentData = tempPayment;
            // Wallet-funded is decided by the payment method (PayAngel Wallet), NOT by
            // wallet_amount — card/bank transfers also carry a wallet_amount value and would
            // otherwise wrongly show the wallet check. senderWalletId (only ever set on wallet
            // transfers) is a fallback. Keep in sync with backend isWalletFunded.
            this.isWalletFunded =
              details.paymentMethod === "PayAngel Wallet" ||
              Boolean(details.senderWalletId);
            if (!this.isWalletFunded) {
              this.walletLegitResult = null;
            }
          }
        });
    },
    async checkWalletLegitimate() {
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.ref_no,
        "ref_no",
      ).toString(this.$CryptoJS.enc.Utf8);
      if (!id) {
        this.$toast.error("Missing transaction reference", {
          position: "top-right",
        });
        return;
      }
      this.walletLegitLoading = true;
      try {
        const response = await this.$store.dispatch(GET_WALLET_LEGIT, id);
        if (response && response.status === 200 && response.data) {
          this.walletLegitResult = response.data;
        } else if (response && response.data && response.data.verdict) {
          // Some clients return body directly
          this.walletLegitResult = response.data;
        } else if (response && response.verdict) {
          this.walletLegitResult = response;
        } else {
          this.$toast.error("Failed to run legitimacy check", {
            position: "top-right",
          });
        }
      } catch (e) {
        this.$toast.error("Failed to run legitimacy check", {
          position: "top-right",
        });
      } finally {
        this.walletLegitLoading = false;
      }
    },
    async payoutDetails() {
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.ref_no,
        "ref_no",
      ).toString(this.$CryptoJS.enc.Utf8);
      await this.$store
        .dispatch(GET_TRANSACTION_PAYOUT_DETAILS, id)
        .then((response) => {
          if (response.status == 200) {
            let details = response.data.details;
            let tempPayout = {
              payoutReferenceId: {
                title: "Payout Reference Id",
                value: details.payoutReferenceId
                  ? details.payoutReferenceId
                  : "-",
                copy: true,
              },
              providerName: {
                title: "Payout Provider",
                value: details.providerName ? details.providerName : "-",
              },
              payoutStatus: {
                title: "Payout Status",
                value: details.payoutStatus ? details.payoutStatus : "-",
              },
              walletAmt: {
                title: "E-Wallet Amount",
                value: details.receiverWalletAmount
                  ? details.receiverWalletAmount
                  : "0",
              },
              middlewareId: {
                title: "PayConnect Id",
                value: details.middlewareId ? details.middlewareId : "-",
              },
            };
            this.payoutDetailData = tempPayout;
          }
        });
    },
    onAccordionToggle(transactionId, index) {
      // Toggle the accordion state
      const isCurrentlyOpen = this.accordionStates[index];
      this.accordionStates[index] = !isCurrentlyOpen;

      // Only fetch if opening (not closing)
      if (!isCurrentlyOpen) {
        this.getproviderResponse(transactionId);
      }
    },
    async getproviderResponse(transactionId) {
      // Check if already fetched (including failed attempts)
      if (
        Object.prototype.hasOwnProperty.call(
          this.providerResponseCache,
          transactionId,
        )
      ) {
        return;
      }

      await this.$store
        .dispatch(GET_TRANSACTION_PROVIDER_RESPONSE, transactionId)
        .then((response) => {
          if (
            response &&
            response.status == 200 &&
            response.data &&
            response.data.details
          ) {
            let details = response.data.details;

            if (details && Array.isArray(details.data)) {
              details.data = details.data.slice().sort((a, b) => {
                const timeA = new Date(a.timestamp || a.requestDate || 0);
                const timeB = new Date(b.timestamp || b.requestDate || 0);
                return timeA - timeB;
              });
            }

            // Cache the response details which contains the data array
            // Use Vue.set to ensure reactivity
            this.$set(this.providerResponseCache, transactionId, details);
          } else {
            // Cache null to prevent repeated API calls
            this.$set(this.providerResponseCache, transactionId, null);
          }
        })
        .catch(() => {
          // Cache null to prevent repeated failed calls
          this.$set(this.providerResponseCache, transactionId, null);
        });
    },
    async getPayoutAttempts() {
      // Get transaction reference id from transactionData (payment reference ID)
      const transactionRefId = this.transactionData?.transactionref?.value;

      if (!transactionRefId || transactionRefId === "-") {
        this.payoutAttempts = [];
        return;
      }

      await this.$store
        .dispatch(GET_PAYOUT_ATTEMPTS, transactionRefId)
        .then((response) => {
          if (response.status == 200 && response.data.details) {
            this.payoutAttempts = response.data.details;
          }
        })
        .catch((error) => {
          console.error("Error fetching payout attempts:", error);
          this.payoutAttempts = [];
        });
    },
    async getComments() {
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.transaction_id,
        "transaction_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      await this.$store
        .dispatch(GET_TRANSACTION_COMMENTS, id)
        .then((response) => {
          if (response.status == 200) {
            let tempcomment = [];
            response.data.details.map((data) => {
              let item = {
                id: data.id,
                name: "Comment Added on",
                date: data.commentdate,
                comment: data.comment,
                created_by: data.created_by,
                edited: true,
                editedby: "Static",
                editMsg: "Static Edit",
                editOn: "2025-02-13 9:54:28",
              };
              tempcomment.push(item);
            });
            // Sort comments by date in descending order (newest first)
            this.usercomments = tempcomment.sort(
              (a, b) => new Date(b.date) - new Date(a.date),
            );
          }
        });
    },
    async getPaymentLogs() {
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.transaction_id,
        "transaction_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      await this.$store
        .dispatch(GET_TRANSACTION_PAYMENTS_LOGS, id)
        .then((response) => {
          console.log(`--- response:`, response);
          if (response.status == 200) {
            console.log(response.data.details);
            this.paymentLogs = response.data.details;
          }
        });
    },
    validateComment() {
      this.commentError = "";

      if (!this.addComment || this.addComment.trim() === "") {
        this.commentError = "Comment cannot be empty";
        return false;
      }

      if (this.addComment.trim().length < 3) {
        this.commentError = "Comment must be at least 3 characters long";
        return false;
      }

      if (this.addComment.trim().length > 10000) {
        this.commentError = "Comment cannot exceed 10000 characters";
        return false;
      }

      return true;
    },
    clearError() {
      this.commentError = "";
    },
    async addCommentHandler() {
      if (!this.validateComment()) {
        return;
      }

      this.isSubmitting = true;

      try {
        const transactionId = this.$CryptoJS.AES.decrypt(
          this.$route.params?.transaction_id,
          "transaction_id",
        ).toString(this.$CryptoJS.enc.Utf8);

        const payload = {
          transaction_id: transactionId,
          comment: this.addComment.trim(),
        };

        const response = await this.$store.dispatch(
          POST_TRANSACTION_COMMENT,
          payload,
        );

        if (response.status === 200) {
          this.$toast.success("Comment added successfully", {
            position: "top-right",
          });
          this.addComment = "";

          await this.getComments();
          this.$nextTick(() => {
            this.scrollToLatest();
          });
        } else {
          throw new Error("Failed to add comment");
        }
      } catch (error) {
        this.commentError = "Failed to add comment. Please try again.";
        this.$toast.error("Failed to add comment", { position: "top-right" });
      } finally {
        this.isSubmitting = false;
      }
    },
    openEditModal(comment) {
      this.currentEditComment = comment;
      this.editComentMsg = comment.comment;
      this.editCommentError = "";
    },
    resetEditModal() {
      this.currentEditComment = null;
      this.editComentMsg = null;
      this.editCommentError = "";
      this.isEditingComment = false;
    },
    validateEditComment() {
      this.editCommentError = "";

      if (!this.editComentMsg || this.editComentMsg.trim() === "") {
        this.editCommentError = "Comment cannot be empty";
        return false;
      }

      if (this.editComentMsg.trim().length < 3) {
        this.editCommentError = "Comment must be at least 3 characters long";
        return false;
      }

      if (this.editComentMsg.trim().length > 500) {
        this.editCommentError = "Comment cannot exceed 500 characters";
        return false;
      }

      return true;
    },
    clearEditError() {
      this.editCommentError = "";
    },
    async updateCommentHandler() {
      if (!this.validateEditComment() || !this.currentEditComment) {
        return;
      }

      this.isEditingComment = true;

      try {
        const transactionId = this.$CryptoJS.AES.decrypt(
          this.$route.params?.transaction_id,
          "transaction_id",
        ).toString(this.$CryptoJS.enc.Utf8);

        const payload = {
          commentId: this.currentEditComment.id,
          transactionId: transactionId,
          comment: this.editComentMsg.trim(),
        };

        const response = await this.$store.dispatch(
          UPDATE_TRANSACTION_COMMENT,
          payload,
        );

        if (response.status === 200) {
          this.$toast.success("Comment updated successfully", {
            position: "top-right",
          });

          // Close modal
          this.$bvModal.hide("editComment");

          // Refresh comments
          await this.getComments();
          this.scrollToLatest();
        } else {
          throw new Error("Failed to update comment");
        }
      } catch (error) {
        this.editCommentError = "Failed to update comment. Please try again.";
        this.$toast.error("Failed to update comment", {
          position: "top-right",
        });
      } finally {
        this.isEditingComment = false;
      }
    },

    // Get activity logs for transaction
    getActivityLogs() {
      const id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.transaction_id,
        "transaction_id",
      ).toString(this.$CryptoJS.enc.Utf8);

      this.activityLogsLoading = true;

      // Import ArchBaseService dynamically
      import("@/common/api.service").then(({ ArchBaseService }) => {
        ArchBaseService.init();
        ArchBaseService.setHeader();

        ArchBaseService.get(`user-activity/logs/${id}/transaction`)
          .then((response) => {
            if (response.status == 200 && response.data.details) {
              this.activityLogs = response.data.details.map((log) => {
                return {
                  ...log,
                  requestExpanded: false,
                  responseExpanded: false,
                  deviceInfoExpanded: false,
                  outcomeExpanded: false,
                  actionExpanded: false,
                };
              });
            } else {
              console.log("Error fetching activity logs:", response);
              this.activityLogs = [];
            }
          })
          .catch((error) => {
            console.error("Failed to fetch activity logs:", error);
            this.activityLogs = [];
          })
          .finally(() => {
            this.activityLogsLoading = false;
          });
      });
    },

    // Helper method to get action text based on HTTP method
    getActionText(method) {
      const methodMap = {
        POST: "Created",
        PUT: "Updated",
        PATCH: "Updated",
        DELETE: "Deleted",
        GET: "Viewed",
      };
      return methodMap[method?.toUpperCase()] || method;
    },

    // Name check modal methods
    async openNameCheckModal() {
      this.isCheckingName = true;
      try {
        // Call name check API
        const transactionId = this.$CryptoJS.AES.decrypt(
          this.$route.params?.transaction_id,
          "transaction_id",
        ).toString(this.$CryptoJS.enc.Utf8);

        await this.$store
          .dispatch(GET_NAME_FROM_NAMECHECK, transactionId)
          .then((response) => {
            if (response.status == 200) {
              this.checkedName = response.data.details.name;
              this.$bvModal.show("nameCheckModal");
            } else {
              this.checkedName = "-";
              this.$toast.warning("No name found from API", {
                position: "top-right",
              });
            }
          });
      } catch (error) {
        console.error("Error calling namecheck API:", error);
        this.$toast.error("Failed to check name. Please try again.", {
          position: "top-right",
        });
      } finally {
        this.isCheckingName = false;
      }
    },

    resetNameCheckModal() {
      // If we're programmatically hiding the modal to open the level selection
      // modal, don't clear the checkedName. The caller sets `skipResetOnHide`.
      if (this.skipResetOnHide) {
        this.skipResetOnHide = false;
        return;
      }

      this.checkedName = "";
      this.isCheckingName = false;
    },

    async confirmNameChange() {
      this.isCheckingName = true;
      try {
        // Close the name check modal
        // Prevent the hidden handler from clearing `checkedName` since
        // we're opening the level selection modal next.
        this.skipResetOnHide = true;
        this.$bvModal.hide("nameCheckModal");
        // Open the change level selection modal
        this.$nextTick(() => {
          this.$bvModal.show("nameChangeLevelModal");
        });
      } catch (error) {
        console.error("Error in confirmNameChange:", error);
        this.$toast.error("Failed to proceed", { position: "top-right" });
      } finally {
        this.isCheckingName = false;
      }
    },

    async handleReceiverLevelChange() {
      try {
        const transactionId = this.$CryptoJS.AES.decrypt(
          this.$route.params?.transaction_id,
          "transaction_id",
        ).toString(this.$CryptoJS.enc.Utf8);

        const payload = {
          transactionId: transactionId,
          updateLevel: "receiver",
          receiverName: this.checkedName.trim(),
        };

        const response = await this.$store.dispatch(
          UPDATE_RECEIVER_NAME,
          payload,
        );

        if (response.status === 200) {
          this.$toast.success("Successfully update name at Receiver Level", {
            position: "top-right",
          });
          await this.remitterReceiverDetails();
          // Close modal
          this.$bvModal.hide("nameChangeLevelModal");
        } else {
          throw new Error("Failed to update name at Receiver Level");
        }
      } catch (error) {
        this.$toast.error("Failed to change name at receiver level", {
          position: "top-right",
        });
      }
    },

    async handleTransactionLevelChange() {
      try {
        const transactionId = this.$CryptoJS.AES.decrypt(
          this.$route.params?.transaction_id,
          "transaction_id",
        ).toString(this.$CryptoJS.enc.Utf8);

        const payload = {
          transactionId: transactionId,
          updateLevel: "transaction",
          receiverName: this.checkedName.trim(),
        };

        const response = await this.$store.dispatch(
          UPDATE_RECEIVER_NAME,
          payload,
        );

        if (response.status === 200) {
          this.$toast.success("Successfully update name at transaction Level", {
            position: "top-right",
          });
          await this.remitterReceiverDetails();
          // Close modal
          this.$bvModal.hide("nameChangeLevelModal");
        } else {
          throw new Error("Failed to update name at transaction Level");
        }
      } catch (error) {
        this.$toast.error("Failed to change name at transaction level", {
          position: "top-right",
        });
      }
    },
  },
  async mounted() {
    await this.remitterReceiverDetails();
    await this.paymentDetails();
    await this.payoutDetails();
    await this.getPayoutAttempts();
    // await this.getproviderResponse();
    await this.getComments();
    await this.getPaymentLogs();
    this.scrollToLatest();
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
    walletLegitBadgeClass() {
      const v = this.walletLegitResult && this.walletLegitResult.verdict;
      return {
        "badge-success": v === "LEGIT",
        "badge-danger":
          v === "SUSPICIOUS" || v === "NOT_THE_PAID_ONE" || v === "NOT_FOUND",
        "badge-warning": v === "INCOMPLETE",
        "badge-secondary": v === "NOT_APPLICABLE",
      };
    },
  },
};
</script>
<style>
.hidden_header {
  display: none;
}
</style>
